export default __webpack_public_path__ + "static/integrated_in_microsoft_teams_and_outlook-f7abaeca833df9bd4cd8aadf9d4c0b9e.svg";